import React, { Component } from 'react';
import { FaInfoCircle, FaUserAlt } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import Estimulos from '../../components/Estimulos';
import ModalSound from '../../components/ModalSound';
import contentTest from '../../services/var';
import { fetchApi } from '../../services/api';

import './style.css';
import Loading from '../../components/Loading';
import { getLink } from '../../services/host';
import ReactTooltip from 'react-tooltip';

class ModuloPaciente extends Component {
  dados = contentTest;
  content = [];
  refs = [];

  constructor(props) {
    super(props);

    const { module_number } = this.props.match.params;

    this.state = {
      id: props.match.params.id !== undefined ? props.match.params.id : null,
      modulo: parseInt(module_number),
      modal: null,
      isLoading: false,
      id_paciente: null,
      nome_paciente: null,
      escolaridade: null,
      nascimento: null,
      idade: '',
      data_teste: '-',
      respostas: [],
    };

    this.edit = this.edit.bind(this);
    this.play = this.play.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    document.title = `Módulo`;
    window.scrollTo(0, 0);

    this.carregaDados();
  }

  carregaDados() {
    this.setState({ isLoading: true });

    fetchApi
      .get(
        process.env.REACT_APP_TESTE_LISTA_RESPOSTAS,
        this.state.id,
        this.state.modulo,
      )
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            module_complete: response.data.modulos,
            id_paciente: response.data.paciente.id_paciente,
            nascimento: response.data.paciente.nascimento,
            escolaridade: response.data.paciente.escolaridade,
            nome_paciente: response.data.paciente.nome,
            idade: response.data.idade,
            data_teste: response.data.teste.created_at,
            respostas: response.data.respostas,
          });
        }
      })
      .catch((err) => {})
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  edit(id) {
    this.setState({
      modal: <ModalSound id={id} close={this.closeModal} />,
    });
  }

  closeModal(id = null, score = 0, tr = 0) {
    this.setState({
      modal: null,
    });

    //atualiza dados
    const index = this.state.respostas?.findIndex(
      (resposta) => resposta.id_resposta === id,
    );
    if (index >= 0) {
      const updatedRespostas = [...this.state.respostas];
      updatedRespostas[index] = {
        ...updatedRespostas[index],
        score: score,
        tempo_reacao: score === 1 ? tr : 0,
        status: score === 1 ? 'correto' : 'incorreto',
        is_verified: true,
      };
      this.setState({
        respostas: updatedRespostas,
      });
    }
  }

  play(id) {
    this.content.forEach((child, i) => {
      if (child.type === Estimulos) {
        console.log(i + ' - ' + id);
        if (i === id) {
          //reproduz botao
          this[`estimulo${i}`].play();
          console.log('TOCA');
        } else {
          //para audio
          this[`estimulo${i}`].stop();
          console.log('PARA');
        }
      }
    });
  }

  verify(id, is_verified) {}

  render() {
    this.content = [];
    //for(var i = 0; i < this.state.respostas.length; i++) {
    this.state.respostas.map((value, index) => {
      this.content.push(
        <Estimulos
          onRef={(ref) => (this[`estimulo${index}`] = ref)}
          key={index}
          id={value.id_resposta}
          nome={`${index + 1}. ${this.dados[this.state.modulo - 1][0][index]}`}
          cor={
            this.state.modulo === 3
              ? this.dados[this.state.modulo - 1][1][index]
              : undefined
          }
          score={value.score}
          tr={value.tempo_reacao}
          edit={() => {
            this.edit(value.id_resposta);
          }}
          audio={value.audio}
          play={() => {
            this.play(index);
          }}
          status={value.status}
          is_verified={value.is_verified}
          verify={() => {
            this.verify(index, value.is_verified);
          }}
        />,
      );

      return value;
    });

    return (
      <div>
        <Header />

        <div className="content">
          <TopPage
            title={this.state.nome_paciente}
            back={getLink(`/teste/${this.state.id}/modulos`)}
            small={`Data de nascimento: ${this.state.nascimento} - ${this.state.idade}`}
            small2={`Escolaridade: ${this.state.escolaridade}`}
            small3={`Data do teste: ${this.state.data_teste}`}
            icon={true}
          >
            <FaUserAlt />
          </TopPage>

          <div className="container">
            <div className="title-modulo">Módulo {this.state.modulo}</div>

            <div
              className={`header-estimulos${this.state.modulo === 3 ? ' header-estimulos-3' : ''}`}
            >
              <div>
                Estímulo{' '}
                <div
                  className="btn-default"
                  data-tip="Estímulo é a resposta correta esperada do paciente."
                  data-for={`tooltip-module-${this.state.id}`}
                >
                  <FaInfoCircle />
                </div>
              </div>
              {this.state.modulo === 3 ? <div>Palavra escrita</div> : null}
              <div>Escore</div>
              <div>Tempo de Reação (TR)</div>
              <div>
                Status{' '}
                <div
                  className="btn-default"
                  data-tip="<div>🟩 <b>Correto</b> — falou a palavra alvo<br/>🟨 <b>Validar</b> — não reconheceu a fala e nem o tempo de reação<br/>🟥 <b>Incorreto</b> — falou a palavra errada</div>"
                  data-for={`tooltip-status-${this.state.id}`}
                  data-html="true"
                >
                  <FaInfoCircle />
                </div>
              </div>
              <div>
                Validação{' '}
                <div
                  className="btn-default"
                  data-tip="Todas as respostas devem ser validadas manualmente para garantir a precisão da avaliação"
                  data-for={`tooltip-module-${this.state.id}`}
                >
                  <FaInfoCircle />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                Ações
              </div>
            </div>

            {this.content.map((value, index) => {
              return value;
            })}
          </div>
        </div>

        <Footer />

        {this.state.isLoading ? <Loading /> : null}

        {this.state.modal}

        <ReactTooltip
          id={`tooltip-module-${this.state.id}`}
          place="bottom"
          effect="solid"
          className="tooltip-module"
        />

        <ReactTooltip
          id={`tooltip-status-${this.state.id}`}
          place="bottom"
          effect="solid"
          className="tooltip-module"
          html={true}
        />
      </div>
    );
  }
}

export default withRouter(ModuloPaciente);
